import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import i18next from 'i18next';

@Directive({
  selector: '[translate]',
  standalone: true
})
export class TranslateDirective implements OnInit {
  @Input('translate') key!: string;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    const translationKey = this.key || this.el.nativeElement.innerText.trim();
    const value = i18next.t(translationKey);
    this.el.nativeElement.innerText = value;
  }
}
